import React, { useState } from "react";
import { useReactFlow, useViewport } from "reactflow";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { StriimInputField } from "@striim/striim-ui-v2";

const sxStyles = {
    container: {
        display: "flex",
        alignItems: "center",
        borderRadius: "12px",
        height: 36,
        overflow: "hidden",
        boxShadow: "40px 0px 30px 20px rgba(235, 242, 250, 0.85)",
        background: "rgba(235, 242, 250, 1)"
    },
    iconButton: {
        borderRadius: 0,
        width: 36,
        height: "100%",
        color: "#567280"
    },
    zoomIcon: {
        fontSize: 16
    },
    zoomSelectWrapper: {
        width: 85
    }
};

const ZOOM_PRESETS = [
    { label: "50%", value: 50 },
    { label: "75%", value: 75 },
    { label: "100%", value: 100 }
];

const ZoomControls: React.FC = React.memo(() => {
    const { zoomIn, zoomOut, zoomTo } = useReactFlow();
    const { zoom } = useViewport();

    const zoomPercent = Math.round(zoom * 100);

    const handlePresetSelect = (preset: number) => {
        zoomTo(preset / 100, { duration: 200 });
    };

    return (
        <Box sx={sxStyles.container}>
            <IconButton
                size="small"
                onClick={() => zoomOut({ duration: 200 })}
                sx={sxStyles.iconButton}
                data-test-id="zoom-out"
            >
                <RemoveIcon sx={sxStyles.zoomIcon} />
            </IconButton>

            <Box sx={sxStyles.zoomSelectWrapper} data-test-id="zoom-select">
                <StriimInputField
                    select
                    SelectProps={{
                        options: ZOOM_PRESETS,
                        menuPlacement: "top",
                        menuPosition: "fixed",
                        menuPortalTarget: document.body,
                        isClearable: false
                    }}
                    value={{ label: zoomPercent + "%", value: zoomPercent }}
                    onChange={option => handlePresetSelect(option.value)}
                />
            </Box>

            <IconButton
                size="small"
                onClick={() => zoomIn({ duration: 200 })}
                sx={sxStyles.iconButton}
                data-test-id="zoom-in"
            >
                <AddIcon sx={sxStyles.zoomIcon} />
            </IconButton>
        </Box>
    );
});

export default ZoomControls;
